import formatter from '~/helpers/formatter'

export default {
  data: () => ({
    loading: false,
    valid: true,
    labels: {
      name: 'Nombre',
      email: 'Correo electrónico',
      password: 'Contraseña',
      password_confirmation: 'Confirmar contraseña',
      new_password: 'Nueva contraseña',
      new_password_confirmation: 'Confirmar nueva contraseña',
      nombre: 'Nombre',
      primer_apellido: 'Primer apellido',
      segundo_apellido: 'Segundo Apellido',
      curp: 'CURP',
      rfc: 'RFC',
      cargo: 'Cargo',
      abreviatura_titulo: 'Abreviatura de título',
      campuses: 'Planteles',
      campuses_a_cargo: 'Planteles a cargo',
      campuses_a_firmar: 'Planteles a firmar',
      uuid: 'Identificador',
      clave_estatal: 'Clave estatal',
      clave_federal: 'Clave federal',
      clave_pago: 'Clave de pago',
      role: 'Rol',
      clave: 'Clave',
      nivel_de_estudio: 'Nivel de estudio',
      campus: 'Plantel',
      carrera: 'Carrera',
      modalidad: 'Modalidad',
      tipo_rvoe: 'Tipo de RVOE',
      numero_rvoe: 'Número de RVOE',
      fecha_rvoe: 'Fecha de RVOE',
      clave_plan: 'Clave del plan',
      calificacion_maxima: 'Calif. máxima',
      calificacion_minima: 'Calif. mínima',
      calificacion_minima_aprobatoria: 'Calif. mínima aprobatoria',
      archivo_xlsx: 'Archivo XLSX',
      numero_asignatura: 'Número de asignatura',
      clave_asignatura: 'Clave de asignatura',
      id_asignatura: 'ID de asignatura',
      nombre_asignatura: 'Nombre de asignatura',
      ciclo_escolar: 'Ciclo escolar',
      id_observacion: 'ID de observación',
      observacion: 'Observación',
      calificacion: 'Calificación',
      entidad_federativa: 'Entidad federativa',
      fecha_inicio_carrera: 'Fecha de inicio de la carrera',
      fecha_terminacion_carrera: 'Fecha de terminación de la carrera',
      autorizacion_reconocimiento: 'Autorización o reconocimiento del RVOE',
      curp_profesionista: 'CURP del profesionista',
      matricula_profesionista: 'Matricula del profesionista',
      nombre_profesionista: 'Nombre del profesionista',
      primer_apellido_profesionista: 'Primer apellido del profesionista',
      segundo_apellido_profesionista: 'Segundo apellido del profesionista',
      curp_alumno: 'CURP del alumno',
      matricula_alumno: 'Matricula del alumno',
      nombre_alumno: 'Nombre del alumno',
      primer_apellido_alumno: 'Primer apellido del alumno',
      segundo_apellido_alumno: 'Segundo apellido del alumno',
      correo_electronico: 'Correo electrónico',
      fecha_de_expedicion: 'Fecha de expedición',
      modalidad_de_titulacion: 'Modalidad de titulación',
      fecha_examen_profesional: 'Fecha de examen profesional',
      fecha_exencion_examen_profesional: 'Fecha de excención del examen profesional',
      cumplio_servicio_social: 'Cumplió el servicio social',
      fundamento_legal_servicio_social: 'Fundamento legal del servicio social',
      entidad_federativa_expedicion: 'Entidad federativa de expedición',
      institucion_procedencia: 'Institución de procedencia',
      tipo_estudio_antecedente: 'Tipo de estudio del antecedente',
      entidad_federativa_antecedente: 'Entidad federativa del antecedente',
      fecha_inicio_antecedente: 'Fecha de inicio del antecedente',
      fecha_terminacion_antecedente: 'Fecha de terminación del antecedente',
      numero_cedula: 'Número de cedula del antecedente',
      folio: 'Folio',
      folio_control: 'Folio de control',
      estado: 'Estado',
      resultado: 'Resultado de la SEP',
      motivo_cancelacion: 'Motivo de cancelación',
      fecha_firmado: 'Fecha de firma',
      fecha_enviado: 'Fecha de envío',
      fecha_capturado: 'Fecha de captura',
      fecha_autorizado: 'Fecha de autorización',
      anio: 'Año',
      tipo_reporte: 'Tipo de reporte',
      no_datos: 'No hay datos',
      clave_dgp: 'Clave DGP',
      clave_concentradora: 'Clave concentradora',
      version_xml_titulos: 'Versión XML de títulos',
      version_xml_certificados: 'Versión XML de certificados',
      consecutivo_titulos: 'Número consecutivo de títulos',
      consecutivo_certificados: 'Número consecutivo de certificados',
      consecutivo_lote_titulos: 'Número consecutivo de lote de títulos',
      consecutivo_lote_certificados: 'Número consecutivo de lote de certificados',
      wsdl_url_titulos: 'URL de Servicio Web de títulos',
      wsdl_usuario_titulos: 'Usuario de Servicio Web de títulos',
      wsdl_constrasena_titulos: 'Contraseña de Servicio Web de títulos',
      documento_a_firmar: 'Documentos a firmar',
      id_tipo_asignatura: 'ID de tipo de asignatura',
      tipo_asignatura: 'Tipo de asignatura',
      creditos_asignatura: 'Número de créditos de asignatura',
      tipo_certificacion: 'Tipo de certificación',
      tipo_periodo: 'Tipo de periodo',
      genero_alumno: 'Genero del alumno',
      fecha_nacimiento_alumno: 'Fecha de nacimiento del alumno',
      total_asignaturas: 'Total de asignaturas',
      asignaturas_asignadas: 'Asignaturas asignadas',
      promedio_calificaciones: 'Promedio de calificaciones',
      total_creditos: 'Total de créditos',
      creditos_obtenidos: 'Créditos obtenidos',
      numero_ciclos: 'Número de ciclos',
      tipo_periodo: 'Tipo de periodo',
      nombre_lote: 'Nombre de lote',
      archivo_cer: 'Archivo CER',
      archivo_key: 'Archivo KEY',
      cambiar_password: 'Cambiar contraseña',
      folio_pago: 'Folio de pago',
      folio_solicitud: 'Folio de solicitud',
      crear_nuevo_lote: 'Crear un nuevo lote',
      agregar_lote_capturado: 'Agregar a un lote capturado',
      autorizado: 'Autorizado',
      tipo_de_rvoe_a_firmar: 'Tipo de RVOE a firmar',
      tipo_rvoe: 'Tipo de RVOE',
      consecutivo_titulos: 'Número consecutivo de títulos',
      sostenimiento: 'Sostenimiento',
      tipo_documento: 'Tipo de documento',
      nivel_educativo: 'Nivel educativo',
      tipo_plan: 'Tipo de plan',
      opciones: 'Opciones',
      periodo: 'Periodo',
      ciudad: 'Ciudad',
      institucion: 'Institución',
      lugar_expedicion: 'Lugar de expedición',
      campus_origen: 'Plantel origen',
      campus_destino: 'Plantel destino',
      mensaje_no_autorizado: 'No autorizado, solicite la autorización al administrador.',
      mensaje_autorizado: 'Autorizado y listo para capturar títulos y certificados.',
      mensaje_conflicto_carrera: 'Conflicto en la carrera, vuelva a seleccionar la carrera.',
    },
    form: {},
    rules: {},
    errors: {}
  }),

  created() {
    for (let key in this.form) {
      if (this.form[key] !== null && typeof this.form[key] === 'object') {
        for (let i in this.form[key]) {
          let key2 = key + '.' + i
          this.errors[key2] = []
          if (!this.labels[key2]) {
            this.labels[key2] = formatter.titlecase(i)
          }
        }
      }
      else {
        this.errors[key] = []
        if (!this.labels[key]) {
          this.labels[key] = formatter.titlecase(key)
        }
      }
    }

    this.rules.required = (field) => ((v) => !!v || 'El campo ' + (this.labels && this.labels[field] && this.labels[field].toLowerCase() + ' ') + 'es requerido')
  },

  methods: {
    handleErrors(errors) {
      if (errors) {
        this.setErrors(errors)
      }
      else {
        this.clearErrors()
      }
    },

    setErrors(errors) {
      for (let key in this.errors) {
        this.errors[key] = errors[key] || []
      }
    },

    clearErrors() {
      for (let key in this.errors) {
        this.errors[key] = []
      }
    }
  }
}
